import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { BadCreditLoanScreen, TitleSection } from "../../components";

export default function BadCreditLoan() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Bad Credit Loan", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/bad-credit-loan-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <BadCreditLoanScreen />
    </DefaultLayout>
  );
}
